module.exports = __WEBPACK_EXTERNAL_MODULE_16__;


//////////////////
// WEBPACK FOOTER
// external "xmldom"
// module id = 16
// module chunks = 0